<div class="material-position-table-container">
  @if (tableIsLoading && enableComponentLoading) {
    <div class="material-position-table-spinner-container">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
  @if (showSectionTitle && !tableIsLoading) {
    <div class="section-heading"
      data-cy="material-position-table-section-header"><span>Position detail</span>
    </div>
  }
  @if ((enableComponentLoading ? !tableIsLoading : true)) {
    <div class="material-position-table-wrapper"
      >
      @if (showMaterialTitle) {
        <div
          class="claim-position-detail-title"
        data-cy="material-position-table-title">{{material | prettyPrintMaterialNumber | undefinedValue}}</div>
      }
      <div class="material-position-table-header-wrapper">
        @if (editMode) {
          <div
            class="clear-positions-button-wrapper">
            <button (click)="clearPositions()"
              [disabled]="disabledLinkButton()"
              class="btn-text-link clear-positions-link"
              data-cy="material-position-table-button-clear">
              <span class="clear-positions-link-icon iwp-icon-gen_delete"></span>Delete position(s)
            </button>
          </div>
        }
        @if (showButtonAdd) {
          <div
            class="add-position-button-wrapper">
            <button (click)="addPosition()" [disabled]="disableAddPosition()"
              class="btn-primary add-position-button"
              type="button"
              data-cy="material-position-table-button-add">Add Position
            </button>
          </div>
        }
      </div>
      <div class="wrapper-table-gradient">
        <table data-cy="material-position-table" class="list-table material-position-table-position" #tableRef>
          <thead>
            <tr class="list-row" data-cy="material-position-table-header-row">
              @if (showSelections()) {
                <th class="list-header-element material-position-checkbox">
                  <span data-cy="material-position-table-header-element-checkbox">
                    <input type="checkbox"
                      [disabled]="disabledSelectAll()"
                      [checked]="selectAll"
                      [indeterminate]="showIntermediate()"
                      data-cy="material-position-table-check-all-input"
                      (change)="toggleAll()"/>
                  </span>
                </th>
              }
              <th class="list-header-element dynamic material-position-table-small-column">
                <app-tooltip message="Quantity">
                  <span data-cy="material-position-table-header-element-quantity">Quantity</span>
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-position-table-medium-column">
                <app-tooltip message="Decision code">
                  <span data-cy="material-position-table-header-element-decision-code">Decision code</span>
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-position-table-big-column">
                <app-tooltip message="Error code">
                  <span data-cy="material-position-table-header-element-error-code">Error code</span>
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-position-table-small-column">
                <app-tooltip message="TE minutes">
                  <span data-cy="material-position-table-header-element-time-effort">TE minutes</span>
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-position-table-medium-column">
                <app-tooltip message="BI category">
                  <span data-cy="material-position-table-header-element-business-category">BI category</span>
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-position-table-medium-column">
                <app-tooltip message="Handling unit">
                  <span data-cy="material-position-table-header-element-handling-unit">Handling unit</span>
                </app-tooltip>
              </th>
              <th class="list-header-element-context-menu"></th>
            </tr>
          </thead>
          <tbody>
            @for (position of positionItems?.slice(0, maxElements); track trackByIndex(index, position); let index = $index) {
              <tr>
                <td [attr.colspan]="colspan">
                  @if (position.overlayInProgress) {
                    <app-generic-overlay
                      class="material-position-table-action-overlay"
                      (firstButtonEvent)="cancelOverlayInProgress(position)"
                      (secondButtonEvent)="delete(index)">
                    </app-generic-overlay>
                  }
                </td>
              </tr>
              <tr data-cy="material-position-table-row"
                class="list-row material-table-position-row"
                id="material-position-table-{{index}}"
                [ngClass]="{'text-highlighted' : position.selected}">
                @if (showSelections()) {
                  <td class="list-element dynamic material-position-checkbox">
                    <input type="checkbox"
                      [checked]="position.selected"
                      [disabled]="disableTableButtons || position.selectionDisabled"
                      data-cy="material-position-table-check-input"
                      class="material-position-table-check"
                      (change)="togglePosition(position)"
                      id="material-position-table-selection-{{index}}"/>
                  </td>
                }
                <td class="list-element dynamic material-position-table-small-column">
                  @if (position.detail.quantity) {
                    <app-tooltip message="{{position.detail.quantity}}">
                      <span data-cy="material-position-table-element-quantity">{{position.detail.quantity | undefinedValue}} {{material?.salesUnit}}</span>
                    </app-tooltip>
                  }
                  @if (!position.detail.quantity) {
                    <app-warning-inline class="required-for-send"
                      data-cy="material-position-table-required-for-send-quantity"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                </td>
                <td class="list-element dynamic material-position-table-medium-column">
                  @if (position.detail.decision) {
                    <app-tooltip
                      message="{{position.detail.decision | prettyPrintReference}}">
                      <app-tooltip
                        [disable]="disableDependentFieldTooltip(decisionIsValid(position), mandatoryDecisionCodeParentFieldWithErrors)"
                        [tooltipType]="determineDependentFieldTooltipType(mandatoryDecisionCodeParentFieldWithErrors)"
                        [alignIcon]="TooltipAlignmentEnum.LEFT"
                        [message]="decisionCodeTooltip"
                        tooltipCustomClass="max-width-table-tooltip">
                        <span [ngClass]="{'error-text': dependentFieldErrorStyle(decisionIsValid(position), mandatoryDecisionCodeParentFieldWithErrors)}"
                        data-cy="material-position-table-element-decision">{{position.detail.decision | prettyPrintReference}}</span>
                      </app-tooltip>
                    </app-tooltip>
                  }
                  @if (!position.detail.decision) {
                    <app-warning-inline class="required-for-send"
                      data-cy="material-position-table-required-for-send-decision-code"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                  <ng-template #decisionCodeTooltip>
                    @if (mandatoryDecisionCodeParentFieldWithErrors == null && !invalidParentField(ClaimInformationMandatoryFieldsEnum.CLAIM_CODE)) {
                      <ng-container
                      *ngTemplateOutlet="invalidDecisionCodeTooltip, context: {decision: position.detail.decision.code}"></ng-container>
                    }
                    @if (mandatoryDecisionCodeParentFieldWithErrors != null && !invalidParentField(ClaimInformationMandatoryFieldsEnum.CLAIM_CODE)) {
                      <ng-container
                      *ngTemplateOutlet="missingParentTooltip; context:{parent: mandatoryDecisionCodeParentFieldWithErrors, child: 'decision code'}"></ng-container>
                    }
                    @if (invalidParentField(ClaimInformationMandatoryFieldsEnum.CLAIM_CODE) && mandatoryDecisionCodeParentFieldWithErrors != null) {
                      <ng-container
                      *ngTemplateOutlet="invalidParentFieldTooltip; context:{field: ClaimInformationMandatoryFieldsEnum.CLAIM_CODE}"></ng-container>
                    }
                  </ng-template>
                </td>
                <td class="list-element dynamic material-position-table-big-column">
                  @if (position.detail.claimError) {
                    <app-tooltip
                      message="{{position.detail.claimError | prettyPrintReference}}">
                      <span data-cy="material-position-table-element-claim-error">{{position.detail.claimError | prettyPrintReference}}</span>
                    </app-tooltip>
                  }
                  @if (!position.detail.claimError) {
                    <app-warning-inline class="required-for-send"
                      data-cy="material-position-table-required-for-send-claim-error"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                </td>
                <td class="list-element dynamic material-position-table-small-column">
                  @if (!showTimeEffortRequiredForSend(position)) {
                    <app-tooltip
                      message="{{position.detail.timeEffort}}">
                      <span data-cy="material-position-table-element-time-effort">{{position.detail.timeEffort | undefinedValue}}</span>
                    </app-tooltip>
                  }
                  @if (showTimeEffortRequiredForSend(position)) {
                    <app-warning-inline
                      class="required-for-send"
                      data-cy="material-position-table-required-for-send-time-effort"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                </td>
                <td class="list-element dynamic material-position-table-medium-column">
                  @if (position.detail.businessCategory) {
                    <app-tooltip
                      message="{{position.detail.businessCategory | prettyPrintReference}}">
                      <span data-cy="material-position-table-element-business-category">{{position.detail.businessCategory | prettyPrintReference}}</span>
                    </app-tooltip>
                  }
                  @if (!position.detail.businessCategory) {
                    <app-warning-inline class="required-for-send"
                      data-cy="material-position-table-required-for-send-business-category"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                </td>
                <td class="list-element dynamic material-position-table-medium-column"
                  data-cy="material-position-table-column-handling-unit">
                  @if (position.detail.handlingUnit) {
                    <app-tooltip
                      message="{{position.detail.handlingUnit}}">
                      <app-tooltip
                        [disable]="disableDependentFieldTooltip(!position.detail.handlingUnitValidation, mandatoryHandlingUnitParentFieldWithErrors)"
                        [tooltipType]="handlingUnitTooltipType(position.detail)"
                        [alignIcon]="TooltipAlignmentEnum.LEFT"
                        [message]="handlingUnitTooltip"
                        tooltipCustomClass="max-width-table-tooltip">
                        <span data-cy="material-position-table-element-handling-unit"
                        [ngClass]="{'error-text': dependentFieldErrorStyle(handlingUnitIsValid(position.detail), mandatoryHandlingUnitParentFieldWithErrors)}">{{position.detail.handlingUnit | undefinedValue}}</span>
                      </app-tooltip>
                    </app-tooltip>
                  }
                  @if (!position.detail.handlingUnit) {
                    <app-warning-inline class="required-for-send"
                      data-cy="material-position-table-required-for-send-handling-unit"
                      [warningInlineLabel]="requiredForSendLabel"
                    [warningType]="WarningsEnum.WARNING_SEND"></app-warning-inline>
                  }
                  <ng-template #handlingUnitTooltip>
                    @if (mandatoryHandlingUnitParentFieldWithErrors == null && !invalidParentField(ClaimInformationMandatoryFieldsEnum.MATERIAL)) {
                      @if (position.detail.handlingUnitValidation.severity === SeverityEnum.WARNING) {
                        <span>
                          <strong>Handling unit not validated</strong>
                        </span>
                      } @else {
                        <ng-container
                        *ngTemplateOutlet="invalidHandlingUnitTooltip; context: {message :getErrorMessage($safeNavigationMigration(position.detail.handlingUnitValidation?.code), position.detail.handlingUnit)}"></ng-container>
                      }
                    }
                    @if (mandatoryHandlingUnitParentFieldWithErrors != null && !invalidParentField(ClaimInformationMandatoryFieldsEnum.MATERIAL)) {
                      <ng-container
                      *ngTemplateOutlet="missingParentTooltip; context:{parent: mandatoryHandlingUnitParentFieldWithErrors, child: 'handling unit'}"></ng-container>
                    }
                    @if (invalidParentField(ClaimInformationMandatoryFieldsEnum.MATERIAL) && mandatoryHandlingUnitParentFieldWithErrors != null) {
                      <ng-container
                      *ngTemplateOutlet="invalidParentFieldTooltip; context:{field: ClaimInformationMandatoryFieldsEnum.MATERIAL}"></ng-container>
                    }
                  </ng-template>
                </td>
                <td class="list-element position-context-menu">
                  @if (showContextMenu) {
                    <div class="context-menu" ngbDropdown
                      data-cy="material-position-table-element-menu">
                      <app-tooltip [dynamic]="false" message="Position actions" class="display-inline-flex">
                        <span class="iwp-icon-gen_kontextmenu"
                          [ngClass]="{'disable': disableTableButtons || showIntermediate() || selectAll}"
                        ngbDropdownToggle (click)="undoAll()"></span>
                      </app-tooltip>
                      @if (!disableTableButtons) {
                        <div ngbDropdownMenu>
                          @if (canEdit(position.detail)) {
                            <div
                              (click)="edit(position)"
                              ngbDropdownItem data-cy="material-position-table-element-menu-edit">Edit
                            </div>
                          }
                          @if (canDelete(position.detail)) {
                            <div
                              ngbDropdownItem data-cy="material-position-table-element-menu-delete"
                              (click)="overlayInProgress(position)">Delete
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (showViewMore()) {
          <div class="view-more-overlay" data-cy="material-position-table-gradient"></div>
        }
        @if (tableIsLoading && enableTableLoading) {
          <div class="spinner-container">
            <app-loading-spinner></app-loading-spinner>
          </div>
        }
      </div>
      @if (showViewMore()) {
        <div class="list-view-more" data-cy="material-position-table-view-more">
          <button class="btn-text-link" (click)="viewMore()"><span class="text">View More</span></button>
        </div>
      }
      @if (!positionItems || positionItems.length === 0) {
        <div class="list-empty"
          data-cy="material-position-table-empty">
          <div class="list-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
          <div class="list-empty-description">The position list is empty</div>
        </div>
      }
    </div>
  }
</div>


<!-- Decision code and handling unit tooltips templates -->
<ng-template #missingParentTooltip let-parent="parent" let-child="child">
  <span>In order to validate the {{child}} <strong>please enter a valid {{parent}}</strong></span>
</ng-template>

<ng-template #invalidHandlingUnitTooltip let-message="message">
  <span>
    <div [innerHTML]="message"></div>
    <br>
      <p><strong>Please check your entries</strong></p>
    </span>
  </ng-template>

  <ng-template #invalidDecisionCodeTooltip let-decision="decision">
    <span>
      <p>Decision code <strong>{{decision}}</strong> with claim code
      {{claimCodeCode}} <strong>was not found</strong> in the selected supplying packing plant
    {{supplyingPackingPlantCode}}</p>
    <br>
      <p><strong>Please check your entries</strong></p>
    </span>
  </ng-template>

  <ng-template #invalidParentFieldTooltip let-field="field">
    <span><strong>Please enter a valid {{field}}</strong></span>
  </ng-template>
